import React from 'react';
import ReactMarkdown from 'react-markdown';
import PostFeedback from './PostFeedback'
import PostAuthor from './PostAuthor'

const Post = ({ post }) => {
  return (
    <div name={post.id}>
      <div className="article speech-bubble">
        <aside className="labels">
          <span className="label">
            <i style={{backgroundColor:post.category.color}}></i>
            {post.category.name}
          </span>
        </aside>
        <h2>{post.title}</h2>
        <div className="post-body">
          <div className="no-post-overlay">
            <ReactMarkdown source={post.body} linkTarget="_blank" escapeHtml={false} />
          </div>
        </div>  
        <PostFeedback post={post} />
      </div>
      <PostAuthor author={post.author} post={post} />
    </div>
  )
} 

export default Post;